<template lang="pug">
    .store-product-page(v-if="product")
        .store-product-page-media
            .store-product-page-media__main
                img(:src="mainImage.url")
            .store-product-page-media__thumbnails
                div.store-product-page-media__slides.splide(ref="splide")
                    div.splide__track
                        div.splide__list
                            div.splide__slide(v-for="(thumbnail, index) in product.images.data" :key="index" :class="{ 'splide__slide--active': mainImage.id === thumbnail.id }")
                                div.store-product-page-media__slide
                                    img.store-product-page-media__slide-image(:src="thumbnail.url")

                div.store-product-page-media__mobile-slides.mobile-splide(ref="mobileSplide")
                    div.splide__track
                        div.splide__list
                            div.splide__slide(v-for="(thumbnail, index) in product.images.data" :key="index")
                                div.store-product-page-media__slide
                                    img.store-product-page-media__slide-image(:src="thumbnail.url")


        .store-product-page-info
            h2.store-product-page-info__title {{ product.title }}
            .store-product-page-info__price #[span Price:] ${{ product.price }}
            p.store-product-page-info__description {{ product.description }}
            .store-product-page-info__actions
                .store-product-page-info__cart(@click="addToCheckout") Add to cart
</template>

<script>
import UserProductsService from '../services/user-products-service'
import Splide from '@splidejs/splide'
import '@splidejs/splide/dist/css/themes/splide-default.min.css'

export default {
    name: 'store-product-page',
    props: {
        username: {
            type: String,
            required: true,
        },
        productId: {
            type: [String, Number],
            required: true,
        },
    },
    data() {
        return {
            user: null,
            product: null,
            mainImage: null,
        }
    },
    async created() {
        try {
            const {data: {data: user}} = await axios.get(`/api/customer/user/username/${this.username}`)
            this.user = user
            this.fetch()
        } catch {
            this.$router.push('/login')
        }
    },
    methods: {
        fetch() {
            UserProductsService.find(this.user.id, this.productId).then(({data}) => {
                if (!data.data.is_active) {
                    this.$router.push('/')
                }

                this.product = data.data

                this.setDefaultMainImage()
                this.$nextTick(() => {
                    this.initSplide()
                })
            })
        },
        addToCheckout() {
            this.$store.dispatch('Shop/Orders/Cart/addCartItem', {
                type: 'creator',
                payload: {
                    product_id: this.product.id,
                },
                attributes: {
                    product: this.product,
                    image: this.product.images.data.length ? this.product.images.data[0].url : null,
                },
                total: this.product.price,
            })

            this.$router.push({ name: 'shopping-cart-page' })
        },
        initSplide() {
            if (this.$refs.splide) {
                const perPage = this.product.images.data.length > 2 ? 3 : this.product.images.data.length
                const width = this.product.images.data.length > 2 ? 524 : 188 * this.product.images.data.length

                const splide = new Splide(this.$refs.splide, {
                    type: 'loop',
                    perPage: perPage,
                    width: width,
                    height: 148,
                    perMove: 1,
                    gap: 40,
                    pagination: false,
                    arrows: false,
                }).mount()

                const that = this

                splide.on('click', function(slide) {
                    splide.go(slide.index)

                    that.mainImage = that.product.images.data[splide.index]
                })
            }

            if (this.$refs.mobileSplide) {
               new Splide(this.$refs.mobileSplide, {
                    type: 'slide',
                    width: '100%',
                    height: 185,
                    pagination: true,
                    arrows: false,
                }).mount()
            }
        },
        setDefaultMainImage() {
            this.mainImage = this.product.images.data.length ? this.product.images.data[0] : null
        },
    }
}
</script>
